import styled from "styled-components";

const FormGroup = styled.div`
  margin-bottom: 1rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: ${(props) => props.theme.secondary};
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid ${(props) => props.theme.secondaryGrey};
  border-radius: 0.5rem;
  font-size: 0.875rem;
  color: ${(props) => props.theme.secondary};

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.primary};
  }
`;

const SaveButton = styled.button`
  width: 100%;
  padding: 0.5rem;
  background-color: ${(props) => props.theme.primary};
  border: none;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
  color: ${(props) => props.theme.white};
  font-weight: 500;
  margin-top: 0.5rem;

  &:hover {
    opacity: 0.9;
  }
`;

const ErrorMessage = styled.div`
  color: #842029;
  background-color: #f8d7da;
  border: 1px solid #f5c2c7;
  border-radius: 0.5rem;
  padding: 0.75rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
`;

interface SettingsFormProps {
  settingsForm: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  };
  setSettingsForm: React.Dispatch<
    React.SetStateAction<{
      currentPassword: string;
      newPassword: string;
      confirmPassword: string;
    }>
  >;
  onSubmit: (e: React.FormEvent) => void;
  error?: string;
}

export const SettingsForm: React.FC<SettingsFormProps> = ({
  settingsForm,
  setSettingsForm,
  onSubmit,
  error,
}) => {
  return (
    <form onSubmit={onSubmit}>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <FormGroup>
        <Label>Current Password</Label>
        <Input
          type="password"
          name="currentPassword"
          value={settingsForm.currentPassword}
          onChange={(e) =>
            setSettingsForm({
              ...settingsForm,
              currentPassword: e.target.value,
            })
          }
        />
      </FormGroup>
      <FormGroup>
        <Label>New Password</Label>
        <Input
          type="password"
          name="newPassword"
          value={settingsForm.newPassword}
          onChange={(e) =>
            setSettingsForm({ ...settingsForm, newPassword: e.target.value })
          }
        />
      </FormGroup>
      <FormGroup>
        <Label>Confirm New Password</Label>
        <Input
          type="password"
          name="confirmPassword"
          value={settingsForm.confirmPassword}
          onChange={(e) =>
            setSettingsForm({
              ...settingsForm,
              confirmPassword: e.target.value,
            })
          }
        />
      </FormGroup>
      <SaveButton type="submit">Update Password</SaveButton>
    </form>
  );
};
